/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Parentalconsentdoc2Inputs */

const en__field_parentalconsentdoc2 = /** @type {(inputs: _Field_Parentalconsentdoc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parental Consent`)
};

const de__field_parentalconsentdoc2 = /** @type {(inputs: _Field_Parentalconsentdoc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einverständniserklärung`)
};

/**
* | output |
* | --- |
* | "Parental Consent" |
*
* @param {_Field_Parentalconsentdoc2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_parentalconsentdoc2 = /** @type {((inputs?: _Field_Parentalconsentdoc2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Parentalconsentdoc2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_parentalconsentdoc2(inputs)
	return de__field_parentalconsentdoc2(inputs)
});
export { _field_parentalconsentdoc2 as "_field_parentalConsentDoc" }